export const states = {
  PENDING: 'pending',
  IDLE: 'idle',
};
